import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, HostListener } from '@angular/core';
import { EmitterService } from '../services/emitter.service';
import { Utility } from "../shared/utility/utility";
import { countryName } from './lang.pipe';
import { AppDetailsService } from '../services/app-details.services';
import { environment } from '../../environments/environment';
import { ZendeskService } from '../services/zendesk.servcie';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { BannerService } from '../services/banner.service';
import { Router } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { language } from '../shared/utility/config';
import { AjaxService } from '../services/ajax.service'
import { Utilities } from '../services/utilities.services';
import { EnvironmentService } from '../shared/services/environment.services';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  providers: [countryName],
  encapsulation: ViewEncapsulation.None
})
export class AppFooterComponent implements OnInit, OnDestroy {
  selectedItem: any;
  @Input()
  isLoggedIn: boolean;
  @Input()
  ishomePage: boolean;
  cookieClose: boolean;
  countryAccess;
  countryCode;
  isCountryAllowed: number = 0;
  destroy$: Subject<boolean> = new Subject<boolean>();
  langCode;
  isZendeskEnabled = environment.zendeskServiceConfig["isEnabled"];
  mappedLanguageCodes;
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  viewLang: any;
  isUserLoggedIn: boolean;
  currentURL_slug: string;
  userDetail: any;
  isShowTransactionNotification = false;
  transactionNotification;
  jurisdictionVal;
  prevJurisdictionVal;
  isTudiChatEnabled = environment.tugiChatConfig.tugiChatEnabled;

  @HostListener('document:click', ['$event']) onClick(event) {
    if (event.target.classList.contains('overlay')) {
      this.viewLang = false;
    }
  }

  @HostListener("window:scroll", ["$event"]) onWindowScroll() {
    if(this.viewLang){
      this.viewLang=false;
    }
  }

  constructor(
    private emitterService: EmitterService,
    private utils: Utility,
    private appDetailsService: AppDetailsService,
    private zendesk: ZendeskService,
    private bannerService: BannerService,
    private router: Router,
    private userDetailsService: UserDetailsService,
    private ajaxService: AjaxService,
    private utilities: Utilities,
    private environMentService:EnvironmentService
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(lang=>{
      this.langCode = lang;
    });
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode=>{
      this.langCode = langCode;
    });
    this.emitterService.userCountry$.pipe(takeUntil(this.destroy$)).subscribe(country=>{
      if (environment.trustlyCountries.indexOf(country) >= 0) {
        this.getCountry(country);
      } else {
        this.getCountry();
      }
    });
    // this.mappedLanguageCodes = this.utils.mappedLanguageCodes();
    this.mappedLanguageCodes = this.environMentService.getActiveLanguageConfig();

    this.emitterService.showDepositSuccessNotification$.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.transactionNotification = data;
      this.isShowTransactionNotification = data.status;
    });

    /**
     * Footer license changes based on jurisdiction value code
     */

    this.emitterService.jurisdictionValue$.pipe(takeUntil(this.destroy$)).subscribe(jurisdictionVal => {
      if(jurisdictionVal != null){
        this.jurisdictionVal = jurisdictionVal;
      } 
    });    

    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      if(!loginStatus){
        this.ajaxService.isBlockedCountry().then((res)=>{
          this.emitterService.broadCastPrevJurisdictionValue(res?.jurisdiction);
        })
        this.emitterService.prevJurisdictionValue$.pipe(takeUntil(this.destroy$)).subscribe(prevJurisdictionVal => {
          this.jurisdictionVal = prevJurisdictionVal;
        })
      } 
    });
    
    //Ends

    
    
    
  }

  ngOnInit() {
    Promise.resolve(this.appDetailsService.getBlockedCountries())
      .then(
        res => {
          if (res && res["countryCode"] && res["countryCode"]) {
            this.countryCode = res["countryCode"];
          } else {
            this.countryCode = '-NA-';
          }
        },
        SystemError => { }
      );

    /* Curacao logo
     var curacaologo = document.createElement('script');
     curacaologo.setAttribute('src', 'https://1f4df82d-00e3-4287-869f-eae846940212.curacao-egaming.com/ceg-seal.js');
     document.head.appendChild(curacaologo); */

    this.utils.getCookiePopup();
    if (localStorage.getItem('enableCookie')) {
      this.cookieClose = false;
    } else {
      this.cookieClose = true;
    }
  }

  cookieFixedBar() {
    this.utils.setCookiePopup('cookie');
    this.cookieClose = false;
    /*GTM event for current viewing page*/
    this.utils.gtmEvent("cookieConsent", {
      evntType: "optedCookie"
    });
  }

  getCountry(country?: String) {
    if (country) {
      this.isCountryAllowed = 1;
      setTimeout(() => {
        this.emitterService.broadcastsetCountryCurrency(country);
      }, 100);
    } else {
      this.isCountryAllowed = 2;
    }
  }

  toggleZDChat(){
    this.utilities.initChat();
  }

  listClick(event, item) {
    event.preventDefault();
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    let lang = window.location.pathname.substring(1, 3);
    this.langCode = item;
    this.currentURL_slug = window.location.pathname.substring(3);
    if (item && item !== localStorage.getItem("langCode")) {
      this.langCode = item;
      this.bannerService.clearBanners();
      localStorage.setItem("langCode", this.langCode);
      this.emitterService.broadcastLangCode(this.langCode);
      this.router.navigate([this.langCode])
      if (this.isUserLoggedIn) {
        Promise.resolve(this.userDetailsService.checkUserProfile())
          .then(completeUserStatus => {
            this.userDetail = this.userDetailsService.getUserProfileDetails();
            if (completeUserStatus["userProfileCompleted"] && this.userDetail) {
              let signUpData = {};
              signUpData = this.userDetail;
              signUpData["language"] = language[this.langCode];
              
              signUpData = this.utils.modifyUserData(signUpData);

              Promise.resolve(this.ajaxService.doProfileUpdate(signUpData))
                .then
                (res => {
                  localStorage.setItem("langCode", this.langCode); /* setting userlancode when user is loggedin and update language through dropdown */
                  this.utils.reloadPage();
                });
            } else {
              this.utils.reloadPage();
            }
          });
      } else if (!this.isUserLoggedIn) {
        this.utils.reloadPage();
      }
    }
  }

   toggleTugiChat() {
      (window as any).tugiWidget?.openWidget();
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
